export function getBookingPageUxFeatures(url) {
  const checks = [{
    match: /\/i\//,
    kind: 'invalid'
  }, {
    match: /\/v\//,
    kind: 'valid'
  }, {
    match: /\/handover\//,
    kind: 'booking'
  }];
  const found = checks.find(_ref => {
    let {
      match
    } = _ref;
    return match.test(url);
  });
  return [found?.kind ?? 're-booking'];
}